$("#js-paginate-products").on("click", function (e) {
  e.preventDefault();

  const $this = $(this);
  $.get($this.attr("href"))
    .done((res) => {
      const html = $(res);
      const nextResults = $("#js-product-results", html);

      if (nextResults.length > 0 && nextResults[0].children.length > 0) {
        // const url = $("#js-paginate-products").attr("href");
        // history.pushState(window.location.search.substring(1), "", url);
        $("#js-product-results").append($(nextResults).html());

        $(".search__count").html($(".search__count", html).html());
        if (
          $("#js-paginate-products").attr("href") !==
            $("#js-paginate-products", html).attr("href") &&
          $("#js-paginate-products", html).attr("href") !== undefined
        ) {
          $("#js-paginate-products").attr(
            "href",
            $("#js-paginate-products", html).attr("href")
          );
        } else {
          $("#js-paginate-products").remove();
        }
      }
    })
    .catch((err) => console.error("There was an error: ", err));
});

$("#js-paginate-articles").on("click", function (e) {
  e.preventDefault();
  const $this = $(this);

  if (window.location.pathname.includes("/blogs/")) {
    $.get($this.attr("href")).done((response) => {
      $("#js-article-results").append(
        $(response).find("#js-article-results").children()
      );

      if ($(response).find("#js-paginate-articles").attr("href") == undefined) {
        $this.hide();
      }

      $this.attr(
        "href",
        $(response).find("#js-paginate-articles").attr("href")
      );
    });
  } else {
    $.get($this.attr("href")).done((response) => {
      $("#js-article-results").append(
        $(response).find("#js-article-results-next-page").children()
      );

      const oldLink = $(this).attr("href");
      const newLink =
        oldLink.slice(0, -1) + `${parseInt(oldLink[oldLink.length - 1]) + 1}`;

      if ($(response).find("#paginate-article-next").attr("id")) {
        $(this).attr("href", newLink);
      } else {
        $(this).remove();
      }
    });
  }
});
